import { render, staticRenderFns } from "./ElectricalDamageDetailsSection.vue?vue&type=template&id=127e3a66"
import script from "./ElectricalDamageDetailsSection.vue?vue&type=script&lang=ts"
export * from "./ElectricalDamageDetailsSection.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports